import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=367afa6c&scoped=true&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"
import style0 from "./Client.vue?vue&type=style&index=0&id=367afa6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367afa6c",
  null
  
)

component.options.__file = "Client.vue"
export default component.exports